import MyAdmins from "@/views/console/MyAdmins";
import C from "@/utils/constants";

export default [
  {
    path: "my-admins",
    component: MyAdmins,
    meta: {
      roles: [C.ROLE.ADMIN, C.ROLE.AGENT_ENGAGEMENT, C.ROLE.BROKERAGE_ADMIN],
    },
    children: [
      {
        path: "",
        name: "my-admins",
        component: () => import("@/components/console/my-admins/MyAdminsList"),
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
          ],
          hotjar: true,
        },
      },
      { path: "view", redirect: "/console/my-admins" },
      {
        path: "view/:id",
        name: "view-my-admin",
        components: {
          default: () => import("@/components/console/my-admins/MyAdminsList"),
          view: () => import("@/components/console/my-admins/MyAdminDetail"),
        },
        props: {
          view: (route) => {
            return {
              mode: "view",
              adminId: route.params.id,
              parent: "my-admins",
            };
          },
        },
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
          ],
          hotjar: true,
        },
      },
    ],
  },
];
